if (!customElements.get('rp-sample-options')) {
  customElements.define('rp-sample-options', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (summary) this.querySelectorAll('details[open]').forEach(item => {
          if (item !== summary.parentElement) item.open = false;
        });
        const label = event.target.closest('label');
        const input = label && document.getElementById(label.htmlFor);
        if (input) requestAnimationFrame(() => {
          const details = input.closest('details');
          details.querySelector('[data-current]').textContent = input.value;
          details.open = false;
          details.querySelector('summary').focus({ preventScroll: true });
        });
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const details = event.target.closest('details');
          if (details) { details.open = false; details.querySelector('summary').focus(); }
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(item => item.open = false);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
